<template>
  <div class="mask" v-if="dataVal.flag">
    <div class="examTips">
      <div class="examTips_header">
        <div></div>
        <div>考生须知</div>
        <i class="el-icon-error" @click="handleRefund"></i>
      </div>
      <div class="examTips_main">
        <div class="examTips_main_desc" v-html="content">
        </div>
        <div class="examTips_main_btn flex_center" @click="handleTo('/examDetail?id=' + id + '&title=' + title)">开始考试
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataVal"],
  data() {
    return {
      id: '',
      title: '',
      content: "",
    };
  },
  mounted() {

  },
  methods: {
    handleRefund() {
      let data = {
        flag: false,
        submitFlag: false
      }
      this.$emit("ExamTipsCall", data);
    },
    handleTo(url) {
      this.$router.push(url);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        if (newVal.flag) {
          this.id = newVal.id
          this.title = newVal.title
          this.content = newVal.content
        } else {
          this.id = ''
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.examTips {
  background-color: #ebf1fe;
  width: 6.771rem;
  min-height: 3.385rem;
  padding: 0 10px 10px;

  .examTips_header {
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    div {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #0d4987;
    }

    .el-icon-error {
      font-size: 30px;
      color: #0d4987;
      cursor: pointer;
    }
  }

  .examTips_main {
    min-height: 3.073rem;
    background-color: #fff;

    .examTips_main_desc {
      padding: 0.208rem;
      font-size: 17px;
      line-height: 36px;
    }

    .examTips_main_btn {
      width: 140px;
      height: 50px;
      background-color: #0d4987;
      border-radius: 6px;
      font-size: 16px;
      color: #fff;
      margin: 0.208rem auto 0;
      cursor: pointer;
    }
  }
}

@media (max-width: 860px) {
  .examTips {
    background-color: #ebf1fe;
    width: 90%;
    height: 90vh;
    padding: 0 10px 10px;

    .examTips_header {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      color: #0d4987;
    }

    .examTips_main {
      height: calc(90vh - 70px);
      background-color: #fff;

      .examTips_main_desc {
        padding: 20px;
        font-size: 17px;
        line-height: 36px;
        height: calc(90vh - 180px);
        overflow-y: auto;
      }

      .examTips_main_btn {
        width: 140px;
        height: 50px;
        background-color: #0d4987;
        border-radius: 6px;
        font-size: 16px;
        color: #fff;
        margin: 20px auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>